import { useState } from 'react';
import axios from 'axios';
import { LockKeyhole, ArrowRight, Eye, EyeOff, KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../lib/format';

const detail = (err, fallback) => { const d = err.response?.data?.detail; return typeof d === 'string' ? d : Array.isArray(d) ? d.map((x) => x.msg).join(' ') : fallback; };

export function Login({ onSuccess }) {
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError('');
    try { await axios.post(`${API}/auth/login`, { password }); onSuccess(); }
    catch (err) { setError(detail(err, 'Giriş yapılamadı')); }
    finally { setBusy(false); }
  };
  return <div className="login-shell" data-testid="login-page">
    <aside className="login-brand">
      <div className="brand"><div className="brand-mark">F</div><div><b>finpulse</b><small>Finans yönetimi</small></div></div>
      <div className="login-copy"><p className="eyebrow">KUZEY KAHVE & CO.</p><h1>İşletmenizin finansı, tek panelde.</h1><p>Gelir-gider, cari hesaplar, çek portföyü ve nakit akışı — yalnızca size açık.</p></div>
      <small className="login-foot">Bu uygulama tek işletme için özel olarak korunmaktadır.</small>
    </aside>
    <main className="login-main">
      <form className="login-card" onSubmit={submit}>
        <span className="login-icon"><LockKeyhole size={20} /></span>
        <p className="eyebrow">GÜVENLİ GİRİŞ</p>
        <h2>Şifrenizi girin</h2>
        <label>Şifre
          <div className="password-field">
            <input required autoFocus type={show ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password-input" />
            <button type="button" onClick={() => setShow(!show)} aria-label="Şifreyi göster" data-testid="login-toggle-password">{show ? <EyeOff size={16} /> : <Eye size={16} />}</button>
          </div>
        </label>
        {error && <p className="error-text" data-testid="login-error">{error}</p>}
        <button className="primary full" disabled={busy} data-testid="login-submit-button">{busy ? 'Kontrol ediliyor…' : 'Giriş yap'} <ArrowRight size={16} /></button>
        <small className="login-hint">5 hatalı denemeden sonra giriş 15 dakika kilitlenir.</small>
      </form>
    </main>
  </div>;
}

export function PasswordSettings() {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm: '' });
  const [error, setError] = useState('');
  const submit = async (e) => {
    e.preventDefault(); setError('');
    if (form.new_password !== form.confirm) return setError('Yeni şifreler eşleşmiyor');
    try { await axios.post(`${API}/auth/change-password`, { current_password: form.current_password, new_password: form.new_password }); toast.success('Şifre güncellendi'); setForm({ current_password: '', new_password: '', confirm: '' }); }
    catch (err) { setError(detail(err, 'Şifre değiştirilemedi')); }
  };
  return <div className="panel form-card check-form" style={{ marginTop: 18 }} data-testid="password-settings-panel">
    <div className="panel-head"><div><p className="eyebrow">GÜVENLİK</p><h2>Giriş şifresini değiştir</h2></div><KeyRound size={22} color="#087f73" /></div>
    <form onSubmit={submit}>
      <label>Mevcut şifre<input required type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} data-testid="current-password-input" /></label>
      <div className="form-grid">
        <label>Yeni şifre<input required type="password" minLength={8} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} placeholder="En az 8 karakter" data-testid="new-password-input" /></label>
        <label>Yeni şifre (tekrar)<input required type="password" minLength={8} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="confirm-password-input" /></label>
      </div>
      {error && <p className="error-text" data-testid="password-error">{error}</p>}
      <button className="primary" data-testid="save-password-button"><KeyRound size={15} /> Şifreyi güncelle</button>
    </form>
  </div>;
}
